// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HrZJ","top":"styles_top__38MGc","left":"styles_left__1Y7Uh","description":"styles_description__2O5LT"};